// extracted by mini-css-extract-plugin
export default {"wrapper":"WgZAD","head":"Aa2rv","icon":"Z1zz_","label":"r5N9I","categories":"dLVkq","skelet":"WEgQy"};